/** @jsx jsx */
/** @jsxFrag null */
import {jsx} from 'panel';

import {ToastEl} from 'common/components/toast';
import {formatText} from 'common/util/format-text';

import type {ToastArea} from './index';

export function template(this: ToastArea) {
  const {toasts} = this.state;

  return (
    <div sel='.mp-toast-area'>
      {toasts.map((toast) => {
        const resolvedMessage =
          typeof toast.message === `function` ? this.getContext(`i18n`).print(toast.message) : toast.message;
        return (
          <ToastEl
            on={{
              action: () => this.helpers.toastAction(toast),
              close: () => this.helpers.toastClose(toast),
              undo: () => this.helpers.toastUndo(toast),
            }}
            attrs={{
              cta: toast.cta || ``,
              'cta-href': toast.ctaHref || ``,
              'cta-target': toast.ctaTarget || ``,
              elref: toast.elref || `toast${toast.id}`,
              hide: toast.hide,
              'hide-cancel-button': toast.hideCancelButton,
              'is-error': toast.isError,
              undoable: toast.undoable,
              'undo-label': toast.undoLabel || `Undo`,
              timeout: toast.isStatic ? null : toast.timeout,
              type: toast.type,
            }}
          >
            {typeof resolvedMessage === `string` ? formatText(resolvedMessage) : resolvedMessage}
          </ToastEl>
        );
      })}
    </div>
  );
}
